import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { ConfigProvider } from "antd";
import { ThemeProvider } from "styled-components";
import { useLayoutContext } from "../../context/AppContextProvider/LayoutContextProvider";
import { useThemeContext } from "../../context/AppContextProvider/ThemeContextProvider";

const AppThemeProvider = (props) => {
  const { direction } = useLayoutContext();
  const { theme } = useThemeContext();

  const getAntTheme = (theme) => {
    return {
      colorPrimary: theme.palette.primary.main,
      fontFamily: "Poppins,  sans-serif",
    };
  };

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  return (
    <ThemeProvider theme={theme}>
      <ConfigProvider
        direction={direction}
        theme={{
          token: getAntTheme(theme),
          fontFamily: "Poppins,  sans-serif",
        }}
      >
        {props.children}
      </ConfigProvider>
    </ThemeProvider>
  );
};

export default React.memo(AppThemeProvider);

AppThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
